import type { NavigateFunction } from "react-router-dom"

import type { IIndexable } from "@common-shared/types/general.types"

import { HttpHelper as NirvanaHttpHelper } from "@front-shared/helpers/http.helper.ts"
import { ToastrHelper } from "@front-shared/helpers/toastr.helper.tsx"
import { UtilHelper } from "@front-shared/helpers/util.helper.ts"
import type { AvailableHttpMethod } from "@front-shared/types/general.ts"

import { GENERAL_CONFIG } from "../config/general.config"
import { ROUTES_CONFIG } from "../config/routes.config"

export class HttpHelper {
    /**
     * Send request to server
     */
    static async sendRequest(
        url: string,
        data: IIndexable = {},
        method: AvailableHttpMethod = "GET",
        headers = {},
        navigate?: NavigateFunction,
        authorizationHeader?: string,
        unauthorizedRedirectUrl = ROUTES_CONFIG.embedCalculatorManagementLoginUrl,
        ignoreToastErrorCodes: number[] = [],
    ): Promise<any> {
        return await NirvanaHttpHelper.sendRequest(
            url,
            data,
            method,
            import.meta.env.VITE_API_URL,
            headers,
            authorizationHeader,
            undefined,
            ignoreToastErrorCodes,
            ToastrHelper.error,
            ToastrHelper.warning,
            () => {
                UtilHelper.redirectTo(unauthorizedRedirectUrl, navigate)
            },
            authorizationHeader
                ? GENERAL_CONFIG.headers.managementKey
                : undefined,
        )
    }
}
